module.exports = __webpack_public_path__ + "img/analytics.8200a2e4.png";